angular.module('impactx.dialog').service('LoadingDialogService', [
    '$mdPanel',
    'themeFactory',
    '$timeout',
    LoadingDialogService
]);

function LoadingDialogService($mdPanel, themeFactory, $timeout) {
    var panelRef;

    // start() Method has asynchronous functions which can clash with stop() or multiple starts(). This ensures only 1 Reference is set correctly and the others are ignored.
    var startLoad;

    var panelConfig = {
        attachTo: angular.element('body'),
        controller: function () {
            this.theme = themeFactory.getTheme();
        },
        controllerAs: '$ctrl',
        panelClass: 'loading-panel',
        templateUrl: 'shared/dialog/templates/loading-panel.html',
        clickOutsideToClose: false,
        escapeToClose: false,
        focusOnOpen: true
    };

    function start() {
        startLoad = true;
        if (!panelRef) {
            $mdPanel.open(panelConfig).then(function (result) {
                if(startLoad && !panelRef)
                {
                    panelRef = result;
                    $timeout(function () {
                        var loadingWrappers = document.getElementsByClassName("md-panel-outer-wrapper");
                        for (var i = 0; i < loadingWrappers.length; i++) {
                            if (loadingWrappers[i].querySelectorAll(".loading-panel").length > 0) {
                                loadingWrappers[i].style.zIndex = "65536"
                            }
                        }
                    });
                }
                else
                {
                    result.close();
                    result.destroy();
                }
            });
        }
    }

    function stop() {
        startLoad = false;
        if (panelRef) {
            panelRef.close();
            panelRef.destroy();
            panelRef = undefined;
        }
    }

    return {
        start: start,
        stop: stop
    }
}